/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import * as Yup from 'yup'
import {Link, useLocation} from 'react-router-dom'
import {Form, Formik} from 'formik'
import {login, resendVerification} from '../core/_requests'
import {useAuth} from '../core/Auth'
import SocialLoginButtons from '../components/SocialLoginButtons'
import TextInput from '../../widgets/components/Input/TextInput'
import {useIntl} from 'react-intl'
import {CustomButton} from '../../widgets/components/UI/CustomButton'
import {useNavigate} from 'react-router-dom'
import {CustomToast} from '../../widgets/components/UI/CustomToast'
import {FormikProps} from '../core/_models'
import {Modal} from 'react-bootstrap'
import {toast} from 'react-toastify'
import TagManager from 'react-gtm-module'
import {getUserByToken} from '../core/_requests'
import {GTMEvent, loginSuccessMeta, updateUTMParameters} from '../../../hooks/gtmHelpers'
import '../styles/login.scss'
import brandingConfig from '../../../../config/brandingConfig'
import {getLocation} from '../../onboarding/core/_requests'
import {removeNullFields} from '../../../core/_util'
const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'

export function Login() {
  const {formatMessage} = useIntl()
  const [loading, setLoading] = useState(false)
  const [emailDisabled, setEmailDisabled] = useState<boolean>(false)
  const {
    saveAuth,
    setUserToken,
    storeCompanyId,
    setCompanyQueuePosition,
    setUseCase,
    setPlanStatus,
    setInvoiceStatus,
    setTwoFaToken
  } = useAuth()
  const navigate = useNavigate()
  const [errorsArray, setErrorsArray] = useState<string[]>()
  const [showModal, setShowModal] = useState(false)
  const [emailLoading, setEmailLoading] = useState(false)
  const [mailValue, setMailValue] = useState<string>()
  const [loading1, setLoading1] = useState(false)
  const [resendEmailDisabled, setResendEmailDisabled] = useState<boolean>(false)
  const [ipStackData, setIpStackData] = useState<any>()
  const isRecordskeeper = process.env.REACT_APP_BRAND === 'RK'

  const initialValues = {
    email: '',
    password: '',
  }

  const initialEmailValues = {
    email: '',
  }

  const loginSchema = Yup.object().shape({
    email: Yup.string()
      .email(formatMessage({id: 'Invalid email format'}))
      .max(50, formatMessage({id: 'Maximum 50 characters'}))
      .required(formatMessage({id: 'Email is required'})),
    password: Yup.string()
      .min(6, formatMessage({id: 'Minimum 6 characters'}))
      .max(50, formatMessage({id: 'Maximum 50 characters'}))
      .required(formatMessage({id: 'Password is required'})),
  })

  const EmailSchema = Yup.object().shape({
    email: Yup.string()
      .email(formatMessage({id: 'Invalid email format'}))
      .max(50, formatMessage({id: 'Maximum 50 characters'}))
      .required(formatMessage({id: 'Email is required'})),
  })

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const utmSource = urlParams.get('utm_source')
    const utmMedium = urlParams.get('utm_medium')
    const utmCampaign = urlParams.get('utm_campaign')
    const utmContent = urlParams.get('utm_content')
    const utmTerm = urlParams.get('utm_term')
    const gclid = urlParams.get('gclid')

    // Update UTM parameters
    if (utmSource) updateUTMParameters('utm_source', utmSource)
    if (utmMedium) updateUTMParameters('utm_medium', utmMedium)
    if (utmCampaign) updateUTMParameters('utm_campaign', utmCampaign)
    if (utmContent) updateUTMParameters('utm_content', utmContent)
    if (utmTerm) updateUTMParameters('utm_term', utmTerm)
    if (gclid) updateUTMParameters('rk_gclid', gclid)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // set referral
  const referral = new URL(window.location.href).searchParams.get('r') || null
  const lsReferral = localStorage.getItem('referral')
  if (!lsReferral?.length) {
    localStorage.setItem('referral', referral || '')
  }
  useEffect(() => {
    const fetchIpStackData = async () => {
      try {
        const ipStackData = await getLocation()
        setIpStackData(ipStackData.data)
      } catch (err) {
        console.log(err)
      }
    }
    fetchIpStackData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = async (values: any, {setSubmitting}: FormikProps) => {
    setLoading(true)
    try {
      const {
        data: {data, success, errors},
      } = await login(values.email, values.password)
      if (success) {
        if(data?.twoFa){
          setTwoFaToken(data.token)
          navigate('/auth/2fa-verification')
        }else{
          await saveAuth(data)
          setUserToken(data.token)
          localStorage.setItem('signUpCompany', data.signUpCompany)
  
          const {data: userData} = await getUserByToken(data.token)
  
          if (
            userData?.data?.defaultCompanyId !== null &&
            userData?.data?.defaultCompanyId !== undefined
          ) {
            const findCompany = userData?.data?.company?.find(
              (company: {companyId: number}) => company.companyId === userData?.data?.defaultCompanyId
            )
            if (findCompany) {
              storeCompanyId(userData?.data?.defaultCompanyId)
              setCompanyQueuePosition(findCompany?.queuePosition)
              setUseCase(findCompany?.useCase)
              if(userData?.data?.companyPlanStatus?.invoiceStatus){
                setInvoiceStatus(userData.data.companyPlanStatus.invoiceStatus)
              }
              if(userData?.data?.companyPlanStatus?.planStatus){
                setPlanStatus(userData.data.companyPlanStatus.planStatus)
              }
            }
          }
  
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.LoginSuccess,
              signup_method: 'Email',
              metadata: removeNullFields({
                country_name: ipStackData?.country_name || 'NA',
                region_name: ipStackData?.region_name || 'NA',
                city_name: ipStackData?.city || 'NA',
                postcode: ipStackData?.zip || 111111,
                ...loginSuccessMeta(userData.data),
              }),
            },
          })
          if (
            (userData?.data?.company?.length === 0 && isRecordskeeper) ||
            (!userData?.data?.contactVerifiedAt && isRecordskeeper) ||
            (!userData?.data?.contact && isRecordskeeper) ||
            (!userData?.data?.countryDialingCode && isRecordskeeper)
          ) {
            navigate('/auth/info')
          } else {
            navigate('/dashboard')
          }
          if (!localStorage.getItem(I18N_CONFIG_KEY)) {
            window.location.reload()
          }
        }
        
      } else {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.LoginFailed,
            signup_method: 'Email',
            email: `${values.email}`,
            metadata: removeNullFields({
              email: `${values?.email}`,
              country_name: ipStackData?.country_name || 'NA',
              region_name: ipStackData?.region_name || 'NA',
              city_name: ipStackData?.city || 'NA',
              postcode: ipStackData?.zip || 111111,
            }),
          },
        })
        if (errors[0].toString() === 'User is not verified yet') {
          if (data) {
            localStorage.setItem('email', data.email)
            localStorage.setItem('userId', data.userId)
          }
          const userId = localStorage.getItem('userId')
          navigate(`/auth/verify-otp/${userId}`)
        } else if (errors[0].toString() === 'Phone is not verified' && isRecordskeeper) {
          if (data) {
            localStorage.setItem('email', data.email)
            localStorage.setItem('userId', data.userId)
          }
          navigate(`/auth/info`)
        } else if (errors[0].toString() === 'Onboarding is pending' && isRecordskeeper) {
          if (data) {
            localStorage.setItem('email', data.email)
            localStorage.setItem('userId', data.userId)
          }
          navigate(`/onboarding/`)
        }
        setErrorsArray(errors)
        await saveAuth(undefined)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setSubmitting(false)
      setLoading(false)
    }
  }

  const handleOnSubmit = async (values: {email: string}) => {
    setEmailLoading(true)
    try {
      const {
        data: {success, errors},
      } = await resendVerification(values)
      if (success) {
        toast.success(formatMessage({id: 'Please check your email for verification link'}))
        setEmailLoading(false)
        setShowModal(false)
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (error) {
      console.log(error)
      setEmailLoading(false)
    } finally {
      setEmailLoading(false)
    }
  }

  const {state} = useLocation() as any

  return (
    <>
      <Formik
        validationSchema={loginSchema}
        initialValues={initialValues}
        onSubmit={onSubmit}
        validateOnMount
      >
        {(formik) => {
          if (state) {
            initialValues.email = state.email
            setEmailDisabled(true)
          }
          setMailValue(formik?.values?.email)
          return (
            <>
              <Form className='form w-100 px-3' id='kt_login_signin_form'>
                {/* begin::Heading */}
                <div className='text-center' style={{marginBottom: '20px'}}>
                  {/* <h1 className='text-dark fw-bolder mb-3 header'>
                    {formatMessage({id: 'Sign In to Foundercrate'})}
                  </h1> */}
                  <h1 className='text-dark fw-bolder mb-3 header'>
                    {formatMessage({id: `Sign In to ${brandingConfig.brandName}`})}
                  </h1>
                  <div className='text-gray-500 text-center fw-bold fs-4 '>
                    {formatMessage({id: 'New Here?'})}{' '}
                    <Link to='/auth/registration/' className='link-primary fw-bold fs-4 desc'>
                      {formatMessage({id: 'Create an Account'})}
                    </Link>
                  </div>
                </div>
                {/* begin::Heading */}

                {errorsArray?.map((error: string) => (
                  <CustomToast className='mb-lg-15' status={error} />
                ))}

                {/* begin::Form group */}
                <TextInput
                  isMargin={'mb-6'}
                  isDisabled={emailDisabled || loading}
                  fieldName={'email'}
                  formik={formik}
                  fieldType={'text'}
                  placeholder={''}
                  label={formatMessage({id: 'Email'})}
                  toolTipText={formatMessage({id: 'GLOBAL.TOOLTIP.LOGIN.EMAIL'})}
                  isStarRequired={true}
                />
                {/* end::Form group */}

                {/* begin::Form group */}
                <TextInput
                  isMargin={'mb-6'}
                  fieldName={'password'}
                  formik={formik}
                  fieldType={'text'}
                  isPassword={true}
                  placeholder={''}
                  isDisabled={emailDisabled || loading}
                  isForgetPassword={true}
                  label={formatMessage({id: 'Password'})}
                  toolTipText={formatMessage({id: 'GLOBAL.TOOLTIP.LOGIN.PASSWORD'})}
                  isStarRequired={true}
                />
                {/* end::Form group */}

                {/* begin::Wrapper */}

                {/* end::Wrapper */}

                {/* begin::Action */}
                <CustomButton
                  isSubmitting={formik.isSubmitting}
                  isValid={formik.isValid}
                  buttonText={formatMessage({id: 'Continue'})}
                  loading={loading}
                  height={54}
                  disable={loading1}
                />
                {/* end::Action */}

                {/* begin::Login options */}
                <div className=' mb-7'>
                  {/* begin::Separator */}
                  <div className='separator separator-content my-7'>
                    <span className='  fw-semibold fs-6 text-uppercase'>
                      {formatMessage({id: 'Or'})}
                    </span>
                  </div>
                  {/* end::Separator */}
                </div>
                {/* end::Login options */}
              </Form>
              <SocialLoginButtons disable={loading} loading1={loading1} setLoading1={setLoading1} />
            </>
          )
        }}
      </Formik>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false)
        }}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header closeButton>
          <div className='mb-n5'>
            <h2>{formatMessage({id: 'Account not verified'})}</h2>
            <p className='mt-2'>
              {formatMessage({
                id: 'Your account is not yet verified. Please check your email for the verification link. If you have not received it yet, we can resend it to you.',
              })}
            </p>
          </div>
        </Modal.Header>
        <Formik
          initialValues={initialEmailValues}
          validationSchema={EmailSchema}
          onSubmit={handleOnSubmit}
        >
          {(formik) => {
            if (mailValue) {
              initialEmailValues.email = mailValue
              setResendEmailDisabled(true)
            }
            return (
              <Form>
                <Modal.Body>
                  <div>
                    <TextInput
                      isDisabled={resendEmailDisabled}
                      fieldName={'email'}
                      formik={formik}
                      fieldType={'text'}
                      placeholder={formatMessage({id: 'Enter Email'})}
                      label={formatMessage({id: 'Email'})}
                      toolTipText={formatMessage({id: 'GLOBAL.TOOLTIP.LOGIN.EMAIL'})}
                      isStarRequired={true}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer className='p-0'>
                  <button
                    type='button'
                    className='btn btn-light font-size-13 font-weight-400'
                    onClick={() => {
                      setShowModal(false)
                      setLoading(false)
                    }}
                  >
                    {formatMessage({id: 'Cancel'})}
                  </button>
                  <CustomButton
                    isSubmitting={formik.isSubmitting}
                    isValid={formik.isValid}
                    buttonText={formatMessage({id: 'Resend email'})}
                    loading={emailLoading}
                    widthLoading={2}
                    width={2}
                    margin={'me-5 mt-5'}
                  />
                </Modal.Footer>
              </Form>
            )
          }}
        </Formik>
      </Modal>
    </>
  )
}
